<my-content placeholder="navigation">

    <div class="col-sm-12 " style="border-bottom: 1px solid #ccc;"></div>

    <div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
        <div class="modal-dialog-FactSheet">
            <div class="modal-content">
                <div class="modal-header BlueHeader">
                    <h4 class="Heading"> {{ModelFor}}</h4><br>
                    <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()"
                        data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body  col-sm-12 form-group">
                    <iframe width="100%" Height="550 px" [src]="modalURL|safe"></iframe>
                </div>
            </div>
        </div>
    </div>
    @if (true) {
        <div class="container-fluid">
        <div class="table-header-container">
            <div class="table-heading">
            View Library
            </div>
            <form #SearchLibrary="ngForm" [formGroup]="FormSearchLibrary"
            (ngSubmit)="onSearchLibrary(SearchLibrary.value)">
            <div class="d-flex">
                <div class="input-group">
                <input type="text" placeholder="Search here" class="table-search-input form-control"
                    formControlName="txtSearch">
                <span class="input-group-btn">
                    <button class="btn btn-primary" title="Search" type="submit">
                    Go
                    </button>
                </span>
                </div>
                @if (this.RightsID.includes('202028001') || this.RightsID.includes('202028021')) {
                <button class="btn btn-outline-primary mx-2" title="Create New Library" data-toggle="modal"
                    (click)="OpenModal('addlibrary','0','Create Library','ReturnAdvanceSearch')" data-target="#ModalPopUP">
                    <i class="fas fa-plus"></i>
                </button>
                } @else {
                <button class="btn btn-outline-primary mx-2" title="Create New Library" routerLink="/module/0">
                    <i class="fas fa-plus"></i>
                </button>
                }
                <button class="btn btn-outline-primary" title="Advance Search" data-toggle="modal"
                (click)="OpenModal('ndc','0','Filter','ReturnAdvanceSearch')" data-target="#ModalPopUP">
                <i class="fas fa-filter"></i>
                </button>
            </div>
            </form>
        </div>
        <div class="card table-container">
            <table class="custom-table">
            <thead>
                <tr>
                <th>Sr. No.</th>
                <th>Date</th>
                <th>File Category</th>
                <th>File Sub Category</th>
                <th>Product</th>
                <th>Attachments</th>
                <th>File No./Ref No.</th>
                <th>Description</th>
                <th>Update By</th>
                <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <app-table-state
                    [loading]="MsgType == 1"
                    [error]="MsgType == 3 ? DisplayMessage : null"
                    [empty]="MsgType == 2"
                    [rows]="10"
                    [columns]="10">
                </app-table-state>
                @if (libraryDetail?.length > 0) {
                    @for (lbD of libraryDetail | paginate : { itemsPerPage: pageSize, currentPage: pageNumber }; track $index ; let i = $index) {
                        <tr>
                        <td align="center">{{ (pageNumber - 1) * pageSize + i + 1 }}</td>
                        <td>{{ lbD.lbDate | date: "dd-MMM-yyyy" }}</td>
                        <td>{{ lbD.LibraryCategory }}</td>
                        <td>{{ lbD.LibrarySubCategory }}</td>
                        <td>{{ lbD.productName }}</td>
                        <td>
                            <table>
                            @for (lbDFile of lbD.attachment; track $index; let j = $index) {
                                <tr>
                                    <td>
                                        <a href="{{ DownloadURL }}{{ lbDFile.DownloadPath }}">{{ lbDFile.DisplayName }}</a>
                                    </td>
                                </tr>
                            }
                            </table>
                        </td>
                        <td>{{ lbD.fileRef }}</td>
                        <td>{{ lbD.description }}</td>
                        <td>{{ lbD.UserName }}</td>
                        <td>
                            @if (this.RightsID.includes('202028001') || this.RightsID.includes('202028021')) {
                            <a class="icon-btn icon-btn-primary text-decoration-none" data-toggle="modal"
                                (click)="OpenModal('addlibrary',lbD.contextID,'Update Library','ReturnAdvanceSearch')"
                                data-target="#ModalPopUP">
                                <i class="fa fa-pencil" aria-hidden="true"></i>
                            </a>
                            } @else {
                            <a class="icon-btn icon-btn-primary text-decoration-none" routerLink="/module/0">
                                <i class="fa fa-pencil" aria-hidden="true"></i>
                            </a>
                            }
                        </td>
                        </tr>
                    }
                }
            </tbody>
            </table>
        </div>
        @if (filteredData?.length > 0) {
            <div class="d-flex justify-content-between my-3 w-100">
                <div class="w-50">
                    <app-rows-per-page
                    [pageSize]="pageSize"
                    [total]="totalRecords"
                    [pageIndex]="pageNumber"
                    (pageSizeChange)="onPageSizeChange($event)">
                </app-rows-per-page>
                </div>
                <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
            </div>
        }
        </div>
    }@else {
        <!-- <div class="col-sm-12" style="margin-top: 8px;">
            <div class="col-sm-12"
                style="background-color: #eee; border:1px solid #ddd;padding-top:10px; padding-bottom: 10px;">
                <div class="col-sm-4">
                    <form #SearchLibrary="ngForm" [formGroup]="FormSearchLibrary"
                        (ngSubmit)="onSearchLibrary(SearchLibrary.value);">
                        <div class="col-sm-2 text-left height-34">Search</div>
                        <div class="col-sm-6"><input class="form-control" formControlName="txtSearch"
                                placeholder="Search here" name="txtSearch" type="text" value=""></div>
                        <div class="col-sm-2"><input class="btn btn-primary btn-sm-12" type="submit" value="Go"></div>
                        <div class="col-sm-2"> <a title="Advance Search" data-toggle="modal"
                                (click)="OpenModal('ndc','0','Filter','ReturnAdvanceSearch');" data-target="#ModalPopUP"><i
                                    _ngcontent-efg-c1="" class="material-icons"> filter_list </i></a>
                        </div>
                    </form>
                </div>
                <div class="col-sm-4">&nbsp;</div>
                <div class="col-sm-4">
                    <div class="col-sm-8">&nbsp;</div>
                    <div class="col-sm-4 height-34 d-flex justify-content-end ">&nbsp;
                        <div class="form-group col-sm-6"
                            *ngIf="this.RightsID.includes('202028001') || this.RightsID.includes('202028021') ; then ADDLibraryLink else ADDLibrary">
                        </div>
                        <ng-template #ADDLibraryLink>
                            <a href="#" data-toggle="modal" title="Create New Library"
                                (click)="OpenModal('addlibrary','0','Create Library','ReturnAdvanceSearch');"
                                data-target="#ModalPopUP">
                                <i class="material-icons" style="
                                    cursor: pointer;
                                    padding: 7px;
                                    border: 1px solid #dfdfdf;
                                    border-radius: 4px;
                                    background: linear-gradient(
                                        20.39deg,
                                        rgb(255 255 255) 15.57%,
                                        rgb(255 255 255) 100.74%
                                    ) !important;
                                    ">add</i>
                            </a>
                        </ng-template>
                        <ng-template #ADDLibrary>
                            <a href="module/0" title="Create New Library">
                                <i class="material-icons" style="
                                cursor: pointer;
                                padding: 7px;
                                border: 1px solid #dfdfdf;
                                border-radius: 4px;
                                background: linear-gradient(
                                    20.39deg,
                                    rgb(255 255 255) 15.57%,
                                    rgb(255 255 255) 100.74%
                                ) !important;
                                ">add</i>
                            </a>
                        </ng-template>
    
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12" style="margin-top: 8px;"></div>
        <div class=" col-sm-12">
            <div class=" col-sm-12 lefticonD paddingless tableHeading">View Library</div>
            <table width="100%" class="LMtable">
                <tr>
                    <th>S.No.</th>
                    <th>Date</th>
                    <th>File Category</th>
                    <th>File Sub Category</th>
                    <th>Product</th>
                    <th>Attachments</th>
                    <th>File No./Ref No.</th>
                    <th>Description</th>
                    <th>Update By</th>
                    <th>Action</th>
                </tr>
    
                <tr *ngIf="this.MsgType == 1">
                    <td colspan="80">
                        <div class="d-flex align-items-center">
                            <strong>Loading&nbsp;&nbsp;&nbsp;</strong>
                            <div class="spinner-border" role="status"></div>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="this.MsgType == 2">
                    <td colspan="80">&nbsp;<span class="glyphicon glyphicon-info-sign"></span>&nbsp;
                        <span>{{DisplayMessage}}</span>
                    </td>
                </tr>
                <tr *ngIf="this.MsgType == 3">
                    <td colspan="80"><span class="Err">{{DisplayMessage}}</span>
                    </td>
                </tr>
    
                <tr style="border: lightgray solid 1px "
                    *ngFor="let lbD of libraryDetail | paginate: { itemsPerPage: 10, currentPage: pageNumber }; let i=index ">
                    <td>{{(pageNumber - 1) * 10 + i +1 }}</td>
                    <td>{{lbD.lbDate|date:'dd-MMM-yyyy'}}</td>
    
                    <td>{{lbD.LibraryCategory}}</td>
                    <td>{{lbD.LibrarySubCategory}}</td>
                    <td>{{lbD.productName}}</td>
                    <td>
                        <table>
                            <tr
                                *ngFor="let lbDFile of lbD.attachment | paginate: { itemsPerPage: 10, currentPage: pageNumber }; let i=index">
                                <td><a href={{DownloadURL}}{{lbDFile.DownloadPath}}>{{lbDFile.DisplayName}}</a></td>
                            </tr>
                        </table>
                    </td>
                    <td>{{lbD.fileRef}}</td>
                    <td>{{lbD.description}}</td>
                    <td>{{lbD.UserName}}</td>
    
                    <td>
                        <div class="form-group col-sm-6"
                            *ngIf="this.RightsID.includes('202028001') || this.RightsID.includes('202028021') ; then EditLibraryLink else EditLibrary">
                        </div>
                        <ng-template #EditLibraryLink>
                            <a data-toggle="modal"
                                (click)="OpenModal('addlibrary',lbD.contextID,'Update Library','ReturnAdvanceSearch');"
                                data-target="#ModalPopUP"> <img src="assets/resources/images/edit.png"> </a>
                        </ng-template>
                        <ng-template #EditLibrary>
                            <a href="module/0"><img src="assets/resources/images/edit.png"></a>
                        </ng-template>
    
    
                    </td>
                </tr>
            </table><br>
    
            <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
        </div> -->
    }


    <div><br></div>
</my-content>
<my-content placeholder="main">

</my-content>